import {
    createContext,
    FC,
    PropsWithChildren,
    useState,
    useCallback,
    useMemo,
    useContext,
  } from "react";
import { WithLauncherProps } from "ehr-launcher-lib";

const noop = () => null;

const defaultValues = {
    callStatus: {
        isAuthStatusChangeSucc: false,
        isAssignUserSucc: false,
        isUpdateBucketSucc: false,
    },
    updateCallStatus: noop
};

interface CallStatus {
    isAuthStatusChangeSucc?: boolean;
    isAssignUserSucc?: boolean;
    isUpdateBucketSucc?: boolean;
}

interface BannerContext {
    callStatus: CallStatus;
    updateCallStatus: (partial: CallStatus) => void;
}

const BannerContext = createContext<BannerContext>(defaultValues);

export const BannerContextProvider: FC<
  PropsWithChildren<WithLauncherProps>
> = ({ children }) => {
    const [callStatus, setCallStatus] = useState<CallStatus>(defaultValues.callStatus);

    const updateCallStatus = useCallback(
        (changes: Partial<CallStatus>, values?: string) => {
            values ?
                setCallStatus({ ...callStatus, [String(changes)]: values }) :
                setCallStatus({ ...callStatus, ...changes });
        }, [callStatus]);

        const values = useMemo(
                    () => ({
                        callStatus,
                        updateCallStatus,
                    }),
                    [
                        callStatus,
                        updateCallStatus,
                    ],
                  );

     return (<BannerContext.Provider value={values}>{children}</BannerContext.Provider>);
};

export const useBannerContext = () => useContext(BannerContext);
